export default __webpack_public_path__ + "static/airplane-window-0e2af69b1f2b1b1d1d8073d3975fe4c8.jpg";